import { Link, useNavigate } from 'react-router';
import { useAppDispatch, useAppSelector } from '@/state/store';
import { loadJournalEntries, setShowDecksView } from '@/state/features/app';

import styles from './styles.module.scss';
import { MenuIcon, Settings, Library } from 'lucide-react';

interface MenuProps {}

export default function Menu({}: MenuProps) {
    const n = useNavigate();
    const dispatch = useAppDispatch();
    const showDecksView = useAppSelector((state) => state.app.showDecksView);

    const handleToggleDecks = () => {
        dispatch(setShowDecksView(!showDecksView));
    };

    return (
        <div className={styles.Menu}>
            <button onClick={handleToggleDecks} className={styles.MenuItem}>
                <Library color="var(--primary-foreground)" />
            </button>
            <Link to="/settings" className={styles.MenuItem}>
                <Settings color="var(--primary-foreground)" />
            </Link>
        </div>
    );
}
